// extracted by mini-css-extract-plugin
export var container = "_47-0";
export var disabled = "_47-4";
export var fullWidth = "_47-3";
export var lined = "_47-1";
export var selected = "_47-5";
export var tab = "_47-2";